import { SimpleSlider, FluidSlider } from '../../../js/src/__utils/sliders';
import GalleryLightbox from '../../../js/src/__page/lightboxGallery';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		SimpleSlider.init();
		FluidSlider.init();
		GalleryLightbox.init();
		navPosition();
		jQuery( window ).resize(function() {           
			setTimeout(navPosition, 100);
        });
	},
	loaded() {
		navPosition();
	},
	resized() {
		GalleryLightbox.refreshSlider();
		navPosition();
	},
	scrolled() {
		navPosition();
	},
	keyDown() {},
	mouseUp() {},
};
function navPosition() {
	const gallery_slider = jQuery('.gallery-slider__slider-fluid');
	if (gallery_slider.find('.slick-active figure').length > 0) {
		var padding = 30;
		if (jQuery(window).width() < 768) {
			padding = 10;
		}			
		var slide_offet = gallery_slider.find('.slick-active figure').offset().left,
		active_slide_width = gallery_slider.find('.slick-active figure').width(),
		next_btn_width = gallery_slider.find('.slick-next').width(),
		prev_btn = slide_offet + padding,
		next_btn = slide_offet + active_slide_width - next_btn_width - padding;

		gallery_slider.find('.slick-prev').css("left", prev_btn+"px");
		gallery_slider.find('.slick-next').css("left", next_btn+"px");
	}
}
export default controller;
